import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppEnvironment } from '../config/app-environment';
import { AuthService } from './auth.service';

/** Starts a fresh Entra ID sign-in redirect whenever the API rejects the
 * current bearer token (expired, or left over from a since-replaced auth
 * mechanism), so a stale session self-heals instead of leaving the app
 * silently logged-out with no way back in. */
@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(AppEnvironment.apiBaseUrl)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.authService.login();
        }
        return throwError(() => error);
      }),
    );
  }
}
